import "./images_module.module.scss"; import "./images_module.module.scss.json"; import "./index.js"
